module.exports = "/_next/static/images/8d2fac098c932d193cbe757874e14d31-NU_ComplianceTeam_ParkerLogo-08 1_xs.png";